var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"whs-detail-icons"},_vm._l((_vm.amenities),function(amenity){return _c('div',{key:amenity,staticClass:"whs-icon-left whs-detail-icon",class:_vm.amenityIcon(amenity)},[_vm._v(_vm._s(_vm.amenityName(amenity)))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }